
import basindabiz from "../assets/videos/press/basindabiz.mp4";
import FlashTV from "../assets/videos/press/FlashTv.mp4";
import HalkTV from "../assets/videos/press/HalkTv.mp4";
import HalkTvNisan2023 from "../assets/videos/press/HalkTv2.mp4";
import Krt from "../assets/videos/press/KRT.mp4";
import Tele1 from "../assets/videos/press/Tele1.mp4";
import Tv5 from "../assets/videos/press/Tv5.mp4";
import video45lik from "../assets/videos/press/45lik.mp4";

import foto1 from "../assets/images/partners/1.jpeg";
import foto2 from "../assets/images/partners/2.jpg";
import foto3 from "../assets/images/partners/3.jpg";
import foto4 from "../assets/images/partners/4.jpg";
import foto5 from "../assets/images/partners/5.jpg";
import foto6 from "../assets/images/partners/6.jpg";

import Image1 from "../assets/images/about/Image1.jpg";
import Image2 from "../assets/images/about/Image2.jpg";
import Image3 from "../assets/images/about/Image3.jpg";

import president from "../assets/images/HasanAkgun.png";

import logomuz from "../assets/logos/esitIsyeriLogo.png";
import tescil from "../assets/images/tescil.png";

/* TBB Türkiye Belediyeler Birliği */
import photo1 from "../assets/images/TBB/photo1.jpeg";
import photo2 from "../assets/images/TBB/photo2.jpeg";
import photo3 from "../assets/images/TBB/photo3.jpeg";
import photo4 from "../assets/images/TBB/photo4.jpeg";
import photo5 from "../assets/images/TBB/photo5.jpeg";
import photo6 from "../assets/images/TBB/photo6.jpeg";

export const partnersData = [
  { id: 1, title: "ERSE MANTIEVİ EV YEMEKLERİ GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ", image: foto1 },
  { id: 2, title: "ÜSTTEKNİK YEDEK PARÇA İMALATI SANAYİ VE TİCARET LİMİTED ŞİRKETİ", image: foto2 },
  { id: 3, title: "C şirketi", image: foto2 },
  { id: 4, title: "A şirketi", image: foto3 },
  { id: 5, title: "B şirketi", image: foto4 },
  { id: 6, title: "C şirketi", image: foto5 },
  { id: 7, title: "C şirketi", image: foto6 },
  { id: 8, title: "ERSE MANTIEVİ EV YEMEKLERİ GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ", image: foto1 },
  { id: 9, title: "ÜSTTEKNİK YEDEK PARÇA İMALATI SANAYİ VE TİCARET LİMİTED ŞİRKETİ", image: foto2 },
  { id: 10, title: "C şirketi", image: foto2 },
  { id: 11, title: "A şirketi", image: foto3 },
  { id: 12, title: "B şirketi", image: foto4 },
  { id: 13, title: "C şirketi", image: foto5 },
  { id: 14, title: "C şirketi", image: foto6 },
];


export const TBBPhotos = [
  { id: 1, image: photo1 },
  { id: 2, image: photo2 },
  { id: 3, image: photo3 },
  { id: 4, image: photo4 },
  { id: 5, image: photo5 },
  { id: 6, image: photo6 },
];








export const servicesData = [
  { id: 1, title: "yüzde 50", description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. " },
  { id: 2, title: "destek", description: "Esse rem ducimus excepturi fuga quos libero voluptate neque." },
  { id: 3, title: "eşit işyeri", description: " Ut incidunt, iusto libero, eaque ipsamg" },
];

export const pressData = [
  { id: 1, title: "Now", video: basindabiz},
  { id: 2, title: "KRT", video: Krt},
  { id: 3, title: "Tele1", video: Tele1},
  { id: 4, title: "Halk TV", video: HalkTvNisan2023},
  { id: 5, title: "TV5", video: Tv5},
  { id: 6, title: "Halk TV 2", video: HalkTV},
  { id: 7, title: "FlashTV", video: FlashTV},
  { id: 8, title: "video45lik", video: video45lik},
];

export const aboutData = [
  {
    id: "1",
    title: "Eşit İşyeri Nedir?",
    text: "Büyükçekmece Belediyesi olarak; Toplumsal cinsiyet eşitliği ile ilgili farkındalık yaratmak, kadın girişimcilerin sayısını artırmak, kadınların toplumda çağdaş ve güçlü bireyler olarak yer almalarını sağlamak amacıyla Eşit İşyeri Projesi başlatılmıştır.",
    image: Image1,
  },
  {
    id: "2",
    title: "Neden Almalıyım?",
    text: "İşyerinize ait ruhsat ücretlerinde %50 oranında indirim sağlanacaktır. İşyerinize ait ilan ve reklam ücretlerinde %50 oranında indirim sağlanacaktır.",
    image: Image2,
  },
  {
    id: "3",
    title: "Başvuru Şartları",
    text: `- İşyerinde çalışanların %50'sinin ya da daha fazlasının kadın olması
- İşyerinde eşit işi yapan kadın ve erkek çalışanların eşit ücret alması
- İşyerinde işverenler haricinde en az 2 çalışan olması
- Kadınlara mahsus hizmet veren iş yerleri bu proje kapsamı dışındadır. Bu işyerlerinin tespiti Eşit İşyeri Komisyonu tarafından değerlendirilecektir.
- Eşit İşyeri Belgesini alan işyerleri yukarıdaki şartları koruması gerekmektedir. Aksi taktirde Eşit İşyeri Belgesi ve bu proje kapsamında faydalandığı avantajlar Eşit İşyeri Komisyonunca iptal edilecektir.`,
    image: Image3,
  },
];

export const abaoutPresident = [
  { id: 1, title: "BAŞKANIN MESAJI", 
    text: "Eşit İşyeri projemizin amacı, şehrimiz genelinde toplumsal cinsiyet eşitliği ile ilgili farkındalık yaratmak, kadın girişimcilerin sayısını arttırmak, kadınların çalışma hayatatında çağdaş ve güçlü bireyler olarak üretimden yönetime kadar her alanda görev almalarını desteklemek ve toplumsal yaşamın her alanında ve işyerlerinde kadın-erkek eşitliğinin sağlanması konusunda önem vermek ve bu dengeyi gözetmektir.",
    image: president, 
  },
];

export const logo = [
  { id: 1, title: "", image: logomuz },
  { id: 2, title: "", image: tescil },
];
